module.exports = __webpack_public_path__ + "assets/fc4508c39df1c906f03e9a10498d37bf.png";